export const GET_CURRENT_CONTACT = "GET_CURRENT_CONTACT";
export const RESET_CURRENT_CONTACT = "RESET_CURRENT_CONTACT";
export const SET_CURRENT_CONTACT_REQUEST_STATUS = "SET_CURRENT_CONTACT_REQUEST_STATUS";
export const UPDATE_CURRENT_CONTACT = "UPDATE_CURRENT_CONTACT";
